module.exports = __webpack_public_path__ + "img/eco-saliva-test.6f994265.png";